export interface Top_data {
    id : number;

    imgurl : string;

    title : string;

    mos : string;

    font? : string;

    persent : string;

    saleprice : string;

    price : string;

    review? : string;
}

let top:Top_data[] = [
    {
        id : 10,

        imgurl : './img/top/img0.jpg',
        
        title : '[패키지] 져니홈+어뉴+투두 반팔티셔츠 2PACK (MJST7662+MJSU7665+MJST7660)',

        mos : '1',

        font : '[6/8 예약배송]',

        persent : '44%',

        saleprice : '38,900원',

        price : '69,000원',

        review : 'REVIEW : 1',
    },
    {
        id : 12,

        imgurl : './img/top/img1.jpg',
        
        title : '[패키지] 22s/s 반팔티 2PACK',

        mos : '2',

        font : '',

        persent : '33%',

        saleprice : '38,900원',

        price : '59,600원',

        review : 'REVIEW : 24',
    },
    {
        id : 13,

        imgurl : './img/top/img2.jpg',
        
        title : '[패키지] 레코드+픽시+라운드 반팔티셔츠 2PACK (MJST7584+MJST7583+MJST7595)',

        mos : '3',

        font : '',

        persent : '43%',

        saleprice : '38,800원',

        price : '70,400원',

        review : 'REVIEW : 5',
    },
    {
        id : 21,

        imgurl : './img/top/img3.jpg',
        
        title : '트랙패치 반팔티셔츠 크림 JIST7601',

        mos : '4',

        font : '',

        persent : '30%',

        saleprice : '26,500원',

        price : '38,000원',

        review : 'REVIEW : 1',
    },
    {
        id : 14,
        
        imgurl : './img/top/img4.jpg',
        
        title : '[패키지] 스티비베어+스티비 컬리지+올디 반팔티셔츠 2PACK (JJST7596+SHST7597+JIST7587)',

        mos : '5',

        font : '',

        persent : '48%',

        saleprice : '38,800원',

        price : '76,000원',

        review : 'REVIEW : 3',
    },
    {
        id : 15,

        imgurl : './img/top/img5.jpg',
        
        title : '라이닝 니트 베스트 라이트베이지 JNKN7669',

        mos : '6',

        font : '',

        persent : '23%',

        saleprice : '39,800원',

        price : '52,000원',

        review : 'REVIEW : 1',
    },
    {
        id : 17,

        imgurl : './img/top/img6.jpg',
        
        title : '[패키지] 픽시 반팔티셔츠 2PACK MJST7583',

        mos : '7',

        font : '',

        persent : '45%',

        saleprice : '39,800원',

        price : '73,000원',

        review : 'REVIEW : 8',
    },
    {
        id : 19,

        imgurl : './img/top/img7.jpg',
        
        title : '[패키지] 투두 반팔티셔츠 2PACK MJST7660',

        mos : '8',

        font : '',

        persent : '41%',

        saleprice : '39,800원',

        price : '68,000원',

        review : 'REVIEW : 1',
    },
    {
        id : 20,

        imgurl : './img/top/img8.jpg',
        
        title : '[패키지] 헤비 더블체인 반팔티셔츠 2PACK KHST7398',

        mos : '9',

        font : '[6/15 예약배송]',

        persent : '41%',

        saleprice : '39,800원',

        price : '65,800원',

        review : 'REVIEW : 93',
    },
    {
        id : 22,
        
        imgurl : './img/top/img9.jpg',
        
        title : '포티 카라 반팔티셔츠 아이보리 MJST7664',

        mos : '10',

        font : '',

        persent : '24%',

        saleprice : '34,900원',

        price : '45,900원',

        review : '',
    },
]

export default top;